import { QueryFeature } from '../../../config/queryClient';

enum QueryKey {
  AccountDistributionOrder = 'AccountDistributionOrder',
}

export const queryKeys = {
  accountDistributionOrder: (clientId?: number) => [
    QueryFeature.Settings,
    QueryKey.AccountDistributionOrder,
    clientId,
  ],
};
